import api from '@/apis/di/contractAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid hợp đồng
export const useContractComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onContractComboboxLoadData = (payload, row, column) => {
    payload.sort = 'contract_no';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  const onContractComboboxLoadDataAllActive = (payload, row, column, custom) => {
    payload.sort = 'contract_no';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const contractComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã hợp đồng',
        dataField: 'contract_no',
        width: 110,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên hợp đồng',
        dataField: 'description',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 490,
      },
    ],
    displayField: 'contract_no',
    valueField: 'contract_id',
    queryMode: 'remote',
    quickSearch: 'ContractQuickSearch',
    quickSearchParam: {
      isFilter: true,
      filterFunc: x => !x.inactive,
    },
    dropdownWidth: 600,
    comboboxLoadData: onContractComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    contractComboConfig,
    onContractComboboxLoadData,
    onContractComboboxLoadDataAllActive // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
